import request from '@/utils/request'
export function getQRStatus(query) {
    return request({
        url: '/wx/server-wx/wxuser/getBindStatus',
        method: 'get',
        params: query
    })
}
export function getQRCode(query) {
    return request({
        url: '/wx/server-wx/wxuser/getWxUserInfo',
        method: 'get',
        params: query
    })
}
export function unBindWx(data) {
    return request({
        url: '/wx/server-wx/wxuser/unBindWx',
        method: 'post',
        data
    })
}